"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CapsuleIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.588 4.80195C17.0174 3.48522 14.6581 3.69212 13.342 5.26204L10.0926 9.13201L15.7959 13.9213L19.0481 10.048C20.3643 8.47741 20.1577 6.11799 18.588 4.80195ZM5.80195 14.242L8.84738 10.615L14.5507 15.4042L11.5081 19.028C10.1919 20.5979 7.8326 20.8048 6.26204 19.4881C4.6922 18.1719 4.48543 15.8126 5.80195 14.242ZM11.8585 4.01742C13.8624 1.62783 17.4428 1.31494 19.832 3.31806C22.2221 5.32186 22.5352 8.90259 20.532 11.292L12.992 20.272C10.9881 22.6621 7.40742 22.9752 5.01797 20.9719C2.62789 18.9681 2.31479 15.3874 4.31806 12.998L11.8585 4.01742ZM14.2698 8.46936C14.8642 7.59848 15.3966 7.19089 15.8349 7.01537C16.2593 6.84545 16.6762 6.86062 17.1196 7.00189L17.5604 5.61812C16.8739 5.39939 16.1007 5.34456 15.2951 5.66713C14.5035 5.98411 13.7658 6.63152 13.0703 7.65064L14.2698 8.46936Z",
  fill: "currentColor"
}));

var _default = CapsuleIcon;
exports.default = _default;